import React from 'react';
import { SecurityContextTemplate, SecurityContextCommonProps } from 'framework/authorization';
import { useEmployeeService } from 'domain/shared/employee';

const EMPLOYEE_PERFORMANCE_CONTEXT = 'EmployeePerformance';

const EmployeeScoreContext = ({ permissionToCheck, children }: SecurityContextCommonProps) => {
  const { getGlobalPeopleManagementPermissions } = useEmployeeService();

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getGlobalPeopleManagementPermissions}
      permissionToCheck={permissionToCheck}
      contextName={EMPLOYEE_PERFORMANCE_CONTEXT}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default EmployeeScoreContext;
